import script from "./IndexPegawai.vue?vue&type=script&setup=true&lang=js"
export * from "./IndexPegawai.vue?vue&type=script&setup=true&lang=js"

import "./IndexPegawai.vue?vue&type=style&index=0&id=46eaa19d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46eaa19d"]])

export default __exports__